import * as yup from 'yup';

const onboardSkillModalFormValidation = yup.object().shape({
  name: yup.string().trim().label('Skill'),

});
export default onboardSkillModalFormValidation;
